import useSWR from 'swr';
import { fetcher } from '../../services/fetcher';
import { moduleConfig } from './config';

export interface Supplier {
  id: number;
  name?: string;
  name2?: string;
  contactPerson?: string;
  address?: string;
  city?: string;
  zipCode?: string;
  state?: string;
  countryId?: number;
  website?: string;
  phone?: string;
  phone2?: string;
  email?: string;
  email2?: string;
  notes?: string;
  vatNumber?: string;
  paymentTerms?: number;
  taxAuthorityId?: number;
  isActive: boolean;
  createdAt: string;
  createdById?: number;
  updatedAt?: string;
  updatedById?: number;
  country?: { id: number; name?: string };
  taxAuthority?: { id: number; ta_descr?: string };
  /** Sum of totalOrIncome from all supplier invoices */
  totalTurnover?: number;
  /** Sum of totalOrIncome from supplier invoices in the current year */
  currentYearTurnover?: number;
  /** Date of the most recent supplier invoice */
  lastInvoiceDate?: string | null;
  /** totalOrIncome of the most recent supplier invoice */
  lastInvoiceAmount?: number | null;
}

export interface SuppliersListResponse {
  records?: Supplier[];
  data?: Supplier[];
}

function toSuppliersList(raw: unknown): Supplier[] {
  if (Array.isArray(raw)) return raw;
  if (raw && typeof raw === 'object' && 'records' in raw && Array.isArray((raw as SuppliersListResponse).records)) {
    return (raw as SuppliersListResponse).records!;
  }
  if (raw && typeof raw === 'object' && 'data' in raw && Array.isArray((raw as SuppliersListResponse).data)) {
    return (raw as SuppliersListResponse).data!;
  }
  return [];
}

export const useSuppliers = (searchParams?: string) => {
  const queryString = searchParams ? `?searchParams=${encodeURIComponent(searchParams)}` : '';
  const { data, error, isLoading, mutate } = useSWR<Supplier[] | SuppliersListResponse>(
    `${moduleConfig.module.api.list}${queryString}`,
    fetcher,
    { revalidateOnFocus: true, revalidateOnReconnect: true }
  );

  const suppliers = toSuppliersList(data);
  return {
    data: suppliers,
    clients: suppliers,
    isLoading,
    isError: error,
    mutate,
  };
};

export const useSupplier = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<Supplier>(
    id ? moduleConfig.module.api.detail(id) : null,
    fetcher,
    { revalidateOnFocus: true }
  );

  return {
    data,
    client: data,
    isLoading,
    isError: error,
    mutate,
  };
};
